import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { EhCoursePageRoutingModule } from './eh-course-routing.module';

import { EhCoursePage } from './eh-course.page';
import { SharedComponentsModule } from 'src/app/shared-components/shared-components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    EhCoursePageRoutingModule,
    SharedComponentsModule,

  ],
  declarations: [EhCoursePage]
})
export class EhCoursePageModule {}
